import { message, Modal } from "@pionex-web-kit/components";
import { EMPTY, of } from "rxjs";
import { catchError, filter, flatMap, map, tap } from "rxjs/operators";
import { ParseErrorUtils } from "trade_lib_wrapper";
import { NumberCommonUtils, SafeDecimal } from "trade_utils_lib";
import { OrderCreator } from "../Trading/Grid/tools/OrderCreator";
import { TradeCreateOrderError } from "../Trading/TradeCreateOrderError";
import { toFixed } from "../utils/decimal";
import { $st } from "../utils/i18n";
import NumberUtils from "../utils/NumberUtils";
import { isPionex } from "../utils/platform";
import { PionexReportV2 } from "../utils/report";
import ExchangeDataProvider from "./ExchangeDataProvider";
var TradeUtil = {
  getExchangeProvider: function getExchangeProvider(tradeSelect) {
    return of(tradeSelect.apiKey).pipe(filter(function (apiKey) {
      return !!apiKey;
    }), map(function (apiKey) {
      if (!apiKey) {
        throw "";
      }
      var realApiKey = apiKey;
      return apiKey;
    }), flatMap(function (apiKey) {
      return ExchangeDataProvider.getExchangeDataProvider(apiKey);
    }));
  },
  getGridOrderProfitPercent: function getGridOrderProfitPercent(high, low, number, feeRate) {
    if (isNaN(high) || isNaN(low) || isNaN(number) || low >= high || number < 2) {
      return [0, 0];
    }
    var priceStep = (high - low) / (number - 1);
    var priceBelow = 0;
    var minProfit = 0;
    var maxProfit = 0;
    var feeRateDecimal = feeRate ? Number(feeRate) : 0;
    for (var price = low; price <= high; price += priceStep) {
      if (priceBelow !== 0) {
        if (maxProfit === 0) {
          maxProfit = (price * (1 - feeRateDecimal) - priceBelow * (1 + feeRateDecimal)) / priceBelow;
        }
        minProfit = (price * (1 - feeRateDecimal) - priceBelow * (1 + feeRateDecimal)) / priceBelow;
      }
      priceBelow = price;
    }
    return [minProfit, maxProfit];
  },
  requestGridRequireBalance: function requestGridRequireBalance(exchangeDataProvider, exchange, base, quote, baseAvailable, quoteAvailable, high, low, per_volume, num) {
    var precision = {};
    var limit = {};
    var symbolInfo = TradeUtil.getSymbolPrecision(exchangeDataProvider.api, base, quote);
    if (symbolInfo) {
      precision = {
        amount: symbolInfo.amount,
        price: symbolInfo.precision
      };
      if (symbolInfo.limit) {
        limit = symbolInfo.limit;
      }
    }
    var body = {
      got_base_amount: "".concat(baseAvailable),
      got_quote_amount: "".concat(quoteAvailable),
      market: exchange,
      base: base,
      quote: quote,
      top: high,
      bottom: low,
      per_volume: per_volume,
      row_cnt: num,
      precision: precision,
      limits: limit
    };
    return exchangeDataProvider.checkGridRequireBalance(body);
  },
  getSymbolPrecision: function getSymbolPrecision(api, base, quote) {
    if (api) {
      var symbols = api.getDefaultSymbols().filter(function (symbol) {
        var pair = symbol.symbol;
        return pair === base + quote || pair.toLowerCase() === (base + "/" + quote).toLowerCase();
      });
      if (symbols && symbols.length > 0) {
        return symbols[0];
      }
    }
    return null;
  },
  getRequireBalanceErrMsg: function getRequireBalanceErrMsg(errMsg) {
    if (errMsg === "error_row_is_not_illegal") {
      return TradeCreateOrderError.Grid_Count_Error;
    } else if (errMsg === "error_per_volume_hit_amount_min") {
      return TradeCreateOrderError.Grid_per_Volume_Hit_Amount_Min;
    } else if (errMsg === "error_interval_price_too_small") {
      return TradeCreateOrderError.Grid_Trade_Count_Too_Large;
    } else if (errMsg === "error_grid_price_hit_price_min") {
      return TradeCreateOrderError.Grid_Trade_Price_Offset_Too_Large;
    } else if (errMsg === "error_grid_cost_hit_cost_min") {
      return TradeCreateOrderError.Grid_Trade_PerVolume_Too_Small;
    } else if (errMsg === "error_init_grids_error") {
      return TradeCreateOrderError.Grid_Trade_Unknow_Error;
    } else if (errMsg === "error_duplicate_grid") {
      return TradeCreateOrderError.Grid_Trade_Count_Too_Large;
    } else if (errMsg === "error_price_is_too_broad") {
      return TradeCreateOrderError.Grid_Trade_Price_Is_Too_Broad;
    } else if (errMsg === "error_exchange_busy") {
      return TradeCreateOrderError.Grid_Trade_Exchange_Busy;
    } else if (errMsg === "error_sign_failed") {
      return TradeCreateOrderError.Grid_Trade_Sign_Failed;
    } else if (errMsg === "error_price_is_too_high") {
      return TradeCreateOrderError.Grid_High_Too_High;
    } else if (errMsg === "error_price_is_too_low") {
      return TradeCreateOrderError.Grid_Low_Too_Low;
    }
    return undefined;
  },
  translateIGErr: function translateIGErr(result, symbol) {
    var error = TradeCreateOrderError.IG_INSUFFICIENT_INVEST;
    var err = TradeCreateOrderError.IG_INSUFFICIENT_FUNDS;
    var needBalance = NumberUtils.toPriceBySymbol(result.base_allocate * result.price + result.quote_allocate, symbol);
    switch (result.code) {
      case "BAD_STRATEGY_PARAMETERS":
        return TradeCreateOrderError.Grid_Params_Error;
      case "INSUFFICIENT_INVEST":
        //投资额不足
        error.info.min = result.invest_min ? "".concat(result.invest_min) : "unknow";
        return error;
      case "INSUFFICIENT_FUNDS":
        //资金不足
        err.info.min = "".concat(needBalance, " ").concat(symbol.quote);
        return err;
      case "BAD_BALANCE_ORDER":
        //无效平衡单
        return TradeCreateOrderError.IG_BAD_BALANCE_ORDER;
      case "NO_PRICE":
        //价格获取失败
        return TradeCreateOrderError.Trade_Get_Price_Error;
      case "OUT_OF_BOUNDS":
        return TradeCreateOrderError.IG_OUT_OF_BOUNDS;
      case "NO_ORDER_BOOK":
        //买卖盘获取失败
        return TradeCreateOrderError.Trade_Get_OrderBook_Error;
      case "UNKNOWN_ERROR":
        //未知错误
        return TradeCreateOrderError.Grid_Trade_Unknow_Error;
      default:
        return TradeCreateOrderError.Grid_Trade_Unknow_Error;
    }
  },
  translateGridErrMsgInfo: function translateGridErrMsgInfo(status, base, quote) {
    if (status === "error_balance_not_enough_quote") {
      var err = TradeCreateOrderError.Grid_Trade_Quote_Not_Enough;
      err.info.quote = quote;
      return err;
    } else if (status === "error_balance_not_enough_base") {
      var _err = TradeCreateOrderError.Grid_Trade_Base_Not_Enough;
      _err.info.base = base;
      return _err;
    } else if (status === "error_balance_not_enough_both_side") {
      var _err2 = TradeCreateOrderError.Grid_Trade_Both_Balance_Not_Enough;
      _err2.info.base = base;
      _err2.info.quote = quote;
      return _err2;
    } else if (status === "error_in_get_balance") {
      return TradeCreateOrderError.Grid_Trade_Get_Balance_Error;
    } else if (status === "error_in_place_grid_balance_order") {
      return TradeCreateOrderError.Grid_Error_In_Place_Grid_Balance_Order;
    } else if (status === "error_in_wait_sell_grid_balance") {
      return TradeCreateOrderError.Grid_Error_In_Wait_Sell_Grid_Balance;
    } else if (status === "error_in_grid_stop_loss") {
      return TradeCreateOrderError.Grid_Error_In_Grid_Stop_Loss;
    } else if (status === "error_in_cancel_orders") {
      return TradeCreateOrderError.Grid_Error_In_Cancel_Orders;
    } else if (status === "error_in_place_grid_orders") {
      return TradeCreateOrderError.Grid_Error_In_Place_Grid_Orders;
    } else if (status === "error_in_wait_order_done") {
      return TradeCreateOrderError.Grid_Error_In_Wait_Order_Done;
    } else if (status === "error_none_balances_got") {
      return TradeCreateOrderError.Grid_Trade_Get_Balance_Error;
    } else if (status === "error_got_none_check_grids") {
      return TradeCreateOrderError.Grid_Error_Got_None_Check_Grids;
    } else if (status === "error_not_found_cross_order") {
      return TradeCreateOrderError.Grid_Error_Not_Found_Cross_Order;
    } else if (status === "error_got_none_cb_info") {
      return TradeCreateOrderError.Grid_Error_Got_None_Cb_Info;
    } else if (status === "error_got_unknown_cb_action") {
      return TradeCreateOrderError.Grid_Error_Got_Unknown_Cb_Action;
    } else if (status === "error_add_not_balanced_monitor_error") {
      return TradeCreateOrderError.Grid_Error_Add_Not_Balanced_Monitor;
    } else if (status === "error_add_balanced_monitor_error") {
      return TradeCreateOrderError.Grid_Trade_Unknow_Error;
    } else if (status === "error_stop_in_loss") {
      return TradeCreateOrderError.Grid_Error_Stop_In_Loss;
    } else if (status === "error_balance_not_enough_in_run_time") {
      return TradeCreateOrderError.Grid_Error_Balance_Not_Enough_In_Runtime;
    } else if (status === "error_got_unknown_order_id") {
      return TradeCreateOrderError.Grid_Error_Got_Unknown_Order_Id;
    }
    return undefined;
  },
  getFormatNumberString: function getFormatNumberString(total, symbol) {
    try {
      if (symbol && symbol.precision) {
        return toFixed(total, symbol.precision);
      }
      var totalDecimal = new SafeDecimal(total);
      if (totalDecimal.greaterThanOrEqualTo(1)) {
        return toFixed(total, 4);
      } else {
        return toFixed(total, 8);
      }
    } catch (e) {
      return 0;
    }
  },
  getTraingMinAmount: function getTraingMinAmount(symbol, price) {
    if (!symbol.limit || !price) {
      return undefined;
    }
    var minAmount = 0;
    var minCostAmount = 0;
    if (symbol.limit.amount.min) {
      minAmount = symbol.limit.amount.min;
    }
    if (symbol.limit.cost.min) {
      minCostAmount = symbol.limit.cost.min;
    }
    var result = SafeDecimal.max(minAmount, minCostAmount / price);
    if (result) {
      try {
        return NumberUtils.toAmountNumBySymbol(result.toString(), symbol, SafeDecimal.ROUND_UP);
      } catch (_unused) {
        return undefined;
      }
    }
    return undefined;
  },
  getTraingMinCost: function getTraingMinCost(symbol, price) {
    if (!symbol.limit || !price) {
      return undefined;
    }
    var minBasePrice = 0;
    var minQuotePrice = 0;
    if (symbol.limit.amount.min) {
      minBasePrice = symbol.limit.amount.min * price;
    }
    if (symbol.limit.cost.min) {
      minQuotePrice = symbol.limit.cost.min;
    }
    var result = SafeDecimal.max(minBasePrice, minQuotePrice);
    if (result) {
      try {
        return NumberUtils.toPriceNumBySymbol(result.toString(), symbol, SafeDecimal.ROUND_UP);
      } catch (_unused2) {
        return undefined;
      }
    }
    return undefined;
  },
  translateGridAllErrMsgBeforeCreateOrder: function translateGridAllErrMsgBeforeCreateOrder(status, base, quote) {
    var e1 = TradeUtil.getRequireBalanceErrMsg(status);
    if (e1) {
      return e1;
    } else {
      var e2 = TradeUtil.translateGridErrMsgInfo(status, base, quote);
      if (e2) {
        return e2;
      }
    }
    return undefined;
  },
  // 后边直接用这个
  singleCreateOrder: function singleCreateOrder(request, tradeSelectInfo, orderType, noMessage) {
    var _this = this;
    return this.getExchangeProvider(tradeSelectInfo).pipe(flatMap(function (provider) {
      return provider.api.createOrderObservable(request, null);
    }), catchError(function (error) {
      if (OrderCreator.forceProcessError(error, $st)) {
        // 已处理，不再向外抛出错误
        return EMPTY;
      }
      var err = ParseErrorUtils.parseCreateOrderError(orderType, error, tradeSelectInfo.symbol.base, tradeSelectInfo.symbol.quote, $st);
      TradeUtil.reportCreateOrderResult(orderType, false);
      _this.tradePoliticFilter(error, orderType, function () {
        TradeUtil.alertCreateOrderError(err);
      });
      throw error;
    }), tap(function (data) {
      TradeUtil.reportCreateOrderResult(orderType, true);
      // noMessage || message.success($st("order_create_success"));
      noMessage || message.success($st("order_create_success"));
    }));
  },
  // 2021年6月1日之后政策限制
  tradePoliticFilter: function tradePoliticFilter(error, orderType, callback) {
    // 杠杆代币禁止国内
    if (error.code === -98 || error.code === -99070 || error.code === 40300950) {
      var _error$data$country, _error$data;
      var country = ParseErrorUtils.parseRemoteCountryCodeToString((_error$data$country = (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.country) !== null && _error$data$country !== void 0 ? _error$data$country : "", $st);
      var url = $st("affiche_of_future_country_limit_link");
      Modal.confirm({
        title: $st("leverage_coin_trading_country_disable_desc", {
          country: country
        }),
        okText: $st("bot_trading_country_disable_ok"),
        cancelText: $st("bot_trading_country_disable_details"),
        onCancel: function onCancel() {
          window.open(url);
        },
        onOk: function onOk(close) {
          close();
        }
      });
      return;
    }
    // 机器人禁止国内
    if (error.code === -99 || error.code === -99080) {
      var _error$data$country2, _error$data2;
      var _country = ParseErrorUtils.parseRemoteCountryCodeToString((_error$data$country2 = (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.country) !== null && _error$data$country2 !== void 0 ? _error$data$country2 : "", $st);
      var _url = $st("affiche_of_future_country_limit_link");
      Modal.confirm({
        title: $st("bot_trading_country_disable_desc", {
          bot: $st("".concat(orderType, "_title_desc")),
          country: _country
        }),
        okText: $st("bot_trading_country_disable_ok"),
        cancelText: $st("bot_trading_country_disable_details"),
        onCancel: function onCancel() {
          window.open(_url);
        },
        onOk: function onOk(close) {
          close();
        }
      });
      return;
    }
    callback && callback();
  },
  // 过期替换
  createOrder: function createOrder(requestObserver, tradeSelectInfo, orderType) {
    return requestObserver.pipe(catchError(function (error) {
      //处理本地报错或者检测报错
      var localError = error;
      if (error.constructor === String) {
        var _tradeSelectInfo$symb = tradeSelectInfo.symbol,
          base = _tradeSelectInfo$symb.base,
          quote = _tradeSelectInfo$symb.quote;
        var err = TradeUtil.translateGridAllErrMsgBeforeCreateOrder(error, base, quote);
        if (err) {
          localError = err;
        }
      } else if (error.message) {
        var _tradeSelectInfo$symb2 = tradeSelectInfo.symbol,
          _base = _tradeSelectInfo$symb2.base,
          _quote = _tradeSelectInfo$symb2.quote;
        var _err3 = TradeUtil.translateGridAllErrMsgBeforeCreateOrder(error.message, _base, _quote);
        if (_err3) {
          localError = _err3;
        }
      } else if (error.response && error.response.message) {
        var _tradeSelectInfo$symb3 = tradeSelectInfo.symbol,
          _base2 = _tradeSelectInfo$symb3.base,
          _quote2 = _tradeSelectInfo$symb3.quote;
        var _err4 = TradeUtil.translateGridAllErrMsgBeforeCreateOrder(error.response.message, _base2, _quote2);
        if (_err4) {
          localError = _err4;
        }
      }
      throw {
        localError: localError
      };
    })).pipe(flatMap(function (request) {
      if (!tradeSelectInfo.apiKey) {
        throw $st("trade_create_order_get_apikey_failed");
      }
      return ExchangeDataProvider.getExchangeDataProvider(tradeSelectInfo.apiKey).pipe(flatMap(function (provider) {
        return provider.api.createOrderObservable(request, null);
      }));
    })).pipe(catchError(function (error) {
      if (OrderCreator.forceProcessError(error, $st)) {
        // 已处理，不再向外抛出错误
        return EMPTY;
      }
      if (error.localError) {
        TradeUtil.alertCreateOrderError(error.localError);
      } else {
        //处理下单返回错误
        var err = ParseErrorUtils.parseCreateOrderError(orderType, error, tradeSelectInfo.symbol.base, tradeSelectInfo.symbol.quote, $st);
        TradeUtil.alertCreateOrderError(err);
      }
      TradeUtil.reportCreateOrderResult(orderType, false);
      throw error;
    }), tap(function (data) {
      TradeUtil.reportCreateOrderResult(orderType, true);
      message.success($st("order_create_success"));
    }));
  },
  reportCreateOrderResult: function reportCreateOrderResult(orderType, isSuccess) {
    var order = 0;
    var operation = isSuccess ? 1 : 2;
    if (orderType === "grid") {
      order = 1;
    } else if (orderType === "trailing_stop") {
      order = 2;
    } else if (orderType === "aip") {
      order = 3;
    } else if (orderType === "twap") {
      order = 4;
    } else if (orderType === "stop-limit") {
      order = 5;
    } else if (orderType === "limit") {
      order = 6;
    } else if (orderType === "market") {
      order = 7;
    }
    PionexReportV2.reportCreateOrderResult({
      order: order,
      operation: operation
    });
  },
  alertLocalError: function alertLocalError(error) {
    if (error.msg) {
      message.warning($st(error.msg, error.info));
    } else {
      message.warning(error);
    }
  },
  alertCreateOrderError: function alertCreateOrderError(error) {
    if (error.msg) {
      //Local catch error
      message.warning($st(error.msg, error.info));
    } else if (error.response) {
      var _error$response = error.response,
        code = _error$response.code,
        reason = _error$response.reason,
        msg = _error$response.msg;
      var errMsg = "";
      if (code) {
        errMsg += "code: ".concat(code, " \n");
      }
      if (reason) {
        errMsg += "reason: ".concat(reason, " \n");
      }
      if (msg) {
        errMsg += "msg: ".concat(msg, " \n");
      }
      errMsg += "toatal: ".concat(error.response);
      message.error(errMsg);
    } else {
      message.error(error);
    }
  },
  queryFeeRate: function queryFeeRate(base, quote, exchange, apiKey) {
    return ExchangeDataProvider.getExchangeDataProvider(apiKey).pipe(flatMap(function (data) {
      if (isPionex()) {
        return data.api.queryPionexFeeRate(base, quote);
      } else {
        return data.api.queryExchangeFeeRate(exchange).pipe(map(function (result) {
          var f = new SafeDecimal(result).toNumber();
          var data = {
            makerFeeRate: f,
            takerFeeRate: f
          };
          return data;
        }));
      }
    }));
  },
  queryMakerFeeRate: function queryMakerFeeRate(base, quote, exchange, apiKey) {
    if (!apiKey) {
      return of("0");
    }
    return this.queryFeeRate(base, quote, exchange, apiKey).pipe(map(function (data) {
      return data.makerFeeRate ? "".concat(data.makerFeeRate) : "0";
    }));
  },
  translateOrderErrMsgInfo: function translateOrderErrMsgInfo(status, base, quote) {
    switch (status) {
      case "error_balance_not_enough_quote":
        {
          return $st("grid_err_error_balance_not_enough_quote", {
            quote: quote
          });
        }
      case "error_balance_not_enough_base":
        {
          return $st("grid_err_error_balance_not_enough_base", {
            base: base
          });
        }
      case "error_balance_not_enough_both_side":
        {
          return $st("grid_err_error_balance_not_enough_both_side", {
            base: base,
            quote: quote
          });
        }
      case "Error_to_get_balance":
      case "error_in_get_balance":
        {
          return $st("grid_err_error_in_get_balance");
        }
      case "error_in_place_grid_balance_order":
        {
          return $st("grid_err_error_in_place_grid_balance_order");
        }
      case "error_in_wait_sell_grid_balance":
        {
          return $st("grid_err_error_in_wait_sell_grid_balance");
        }
      case "error_in_grid_stop_loss":
        {
          return $st("grid_err_error_in_grid_stop_loss");
        }
      case "error_in_cancel_orders":
        {
          return $st("grid_err_error_in_cancel_orders");
        }
      case "error_in_place_grid_orders":
        {
          return $st("grid_err_error_in_place_grid_orders");
        }
      case "error_in_wait_order_done":
        {
          return $st("grid_err_error_in_wait_order_done");
        }
      case "error_none_balances_got":
        {
          return $st("grid_err_error_none_balances_got");
        }
      case "error_got_none_check_grids":
        {
          return $st("grid_err_error_got_none_check_grids");
        }
      case "error_not_found_cross_order":
        {
          return $st("grid_err_error_not_found_cross_order");
        }
      case "error_got_none_cb_info":
        {
          return $st("grid_err_error_got_none_cb_info");
        }
      case "error_got_unknown_cb_action":
        {
          return $st("grid_err_error_got_unknown_cb_action");
        }
      case "error_add_not_balanced_monitor_error":
        {
          return $st("grid_err_error_add_not_balanced_monitor_error");
        }
      case "error_add_balanced_monitor_error":
        {
          return $st("grid_err_error_add_balanced_monitor_error");
        }
      case "error_stop_in_loss":
        {
          return $st("grid_err_error_stop_in_loss");
        }
      case "error_balance_not_enough_in_run_time":
        {
          return $st("grid_err_error_balance_not_enough_in_run_time");
        }
      case "error_got_unknown_order_id":
        {
          return $st("grid_err_error_got_unknown_order_id");
        }
      case "loss_stop":
        {
          return $st("grid_pro_loss_stop");
        }
      case "profit_stop":
        {
          return $st("grid_pro_profit_stop");
        }
      case "error":
        {
          return $st("gridPro_err_error");
        }
      case "force_liquidation":
        {
          return $st("gridPro_err_force_liquidation");
        }
      case "INSUFFICIENT_FUNDS":
      case "not_enough_balance":
        {
          return $st("not_enough_balance");
        }
      case "AUTHENTICATION_ERROR":
      case "invalid_api_key":
        {
          return $st("invalid_api_key");
        }
      case "per_volume_hit_amount_min":
        {
          return $st("per_volume_hit_amount_min");
        }
      case "cannot_reach_limit_open_price":
        {
          return $st("cannot_reach_limit_open_price");
        }
      case "ORDER_BOOK_INVALID":
      case "no_orderbook":
        {
          return $st("no_orderbook");
        }
      case "invalid_margin_type":
        {
          return $st("invalid_margin_type");
        }
      case "invalid_position_side":
        {
          return $st("invalid_position_side");
        }
      case "position_not_matched":
        {
          return $st("position_not_matched");
        }
      case "leverage_not_matched":
        {
          return $st("leverage_not_matched");
        }
      case "has_position_before_open":
        {
          return $st("has_position_before_open");
        }
      case "has_open_orders_before_open":
        {
          return $st("has_open_orders_before_open");
        }
      case "not_managed_exchange_order":
        {
          return $st("not_managed_exchange_order");
        }
      case "grid_profit_rate_less_than_fee_rate":
        {
          return $st("grid_profit_rate_less_than_fee_rate");
        }
      case "Error_exchange_order_canceled":
      case "exchange_order_canceled_by_user":
        {
          return $st("exchange_order_canceled_by_user");
        }
      case "Error_to_create_buy_order":
        {
          return $st("error_to_create_buy_order");
        }
      case "Error_to_create_sell_order":
        {
          return $st("error_to_create_sell_order");
        }
      case "Error_to_get_order":
      case "error_in_get_my_trades":
        {
          return $st("error_in_get_my_trades");
        }
      case "Error_insufficient_base_amount":
        {
          return $st("Error_insufficient_base_amount", {
            base: base
          });
        }
      case "Error_insufficient_quote_amount":
        {
          return $st("Error_insufficient_quote_amount", {
            quote: quote
          });
        }
      case "Error_failed_to_lock_amount":
        {
          return $st("Error_failed_to_lock_amount");
        }
      case "CREATE_STRATEGY_FAILED":
      case "Error_failed_to_create_strategy":
        {
          return $st("Error_failed_to_create_strategy");
        }
      case "Error_failed_to_clear_strategy":
        {
          return $st("Error_failed_to_clear_strategy");
        }
      case "STRATEGY_ALLOCATE_FAILED":
      case "Error_failed_to_allocate_strategy":
        {
          return $st("Error_failed_to_allocate_strategy");
        }
      case "Error_failed_to_unlock_amount":
        {
          return $st("Error_failed_to_unlock_amount");
        }
      case "RPC_ERROR":
      case "Error_invalid_rpc_response":
        {
          return $st("Error_invalid_rpc_response");
        }
      case "BAD_BALANCE_ORDER":
        {
          return $st("ERROR_BAD_BALANCE_ORDER");
        }
      case "OUT_OF_BOUNDS_ERROR":
        {
          return $st("ERROR_OUT_OF_BOUNDS_ERROR");
        }
      case "error_in_create_order":
      case "CREATE_EXCHANGE_ORDER_FAILED":
        {
          return $st("ERROR_CREATE_EXCHANGE_ORDER_FAILED");
        }
      case "CANCEL_EXCHANGE_ORDER_FAILED":
        {
          return $st("ERROR_CANCEL_EXCHANGE_ORDER_FAILED");
        }
      case "EXCHANGE_ORDER_STATUS_ERROR":
        {
          return $st("ERROR_EXCHANGE_ORDER_STATUS_ERROR");
        }
      case "ADJUST_ORDER_FAILED":
        {
          return $st("ERROR_ADJUST_ORDER_FAILED");
        }
      case "admin_cancel":
        {
          return $st("Error_admin_cancel");
        }
      case "transfer_error":
        {
          return $st("Error_transfer_error");
        }
      case "auto_close":
        {
          return $st("fsa_order_auto_close");
        }
      case "invalid_argument":
        {
          return $st("Error_invalid_argument");
        }
      default:
        {
          return $st("grid_err_error_manual");
        }
    }
  },
  /**
   * 处理展示单网格利润率
   * @param profitPerGrid
   */
  getProfitPerGridDesc: function getProfitPerGridDesc(profitPerGrid) {
    if (!profitPerGrid) {
      return "";
    }
    if (profitPerGrid.length === 2) {
      var start = processProfitDisplay(profitPerGrid[0]);
      var end = processProfitDisplay(profitPerGrid[1]);
      return "".concat(start, "-").concat(end);
    } else if (profitPerGrid.length === 1) {
      return processProfitDisplay(profitPerGrid[0]);
    }
    return "";
  }
};
function processProfitDisplay(profit) {
  var precision = profit < 0.0001 ? 4 : 2;
  return NumberCommonUtils.toPercent(new SafeDecimal(profit).mul(100), false, true, precision);
}
export default TradeUtil;